module.exports = __webpack_public_path__ + "static/img/skull.a06a9399.png";